import React, {Component} from 'react';
import Axis from './axis';
import GraphBody from './graph-body';

export default class Graph extends Component {
    static defaultProps = {width: 900, height: 600};

    constructor(props) {
        super(props);
        this.state = {
            multiplier: 30,
            left: 0,
            bottom: 0,
        };
        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
        this.moveLeft = this.moveLeft.bind(this);
        this.moveDown = this.moveDown.bind(this);
        this.wheelZoom = this.wheelZoom.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }

    zoomIn(x, y) {
        const nextLeft = (this.state.left + x) * ((this.state.multiplier + 1) / this.state.multiplier) - x;
        this.setState({
            left: nextLeft > 0 ? nextLeft : 0,
            bottom: (this.state.bottom + y) * ((this.state.multiplier + 1) / this.state.multiplier) - y,
            multiplier: this.state.multiplier + 1
        });
    }

    zoomOut(x, y) {
        const nextLeft = (this.state.left + x) * ((this.state.multiplier - 1) / this.state.multiplier) - x;
        if (this.state.multiplier > 1) {
            this.setState({
                left: nextLeft > 0 ? nextLeft : 0,
                bottom: (this.state.bottom + y) * ((this.state.multiplier - 1) / this.state.multiplier) - y,
                multiplier: this.state.multiplier - 1
            });
        }
    }

    moveLeft(d) {
        if (this.state.left >= d) {
            this.setState({
                left: this.state.left - d
            });
        } else {
            this.setState({
                left: 0
            });
        }
    }

    moveDown(d) {
        //if (this.state.bottom >= d) {     //negative Y axis?
            this.setState({
                bottom: this.state.bottom - d
            });
        /*
        } else {
            this.setState({
                bottom: 0
            });
        }
        */
    }

    wheelZoom(e) {
        if (e.deltaY < -99) {
            this.zoomIn(e.nativeEvent.offsetX - 40, this.props.height - 20 - e.nativeEvent.offsetY);
        } else if (e.deltaY > 99) {
            this.zoomOut(e.nativeEvent.offsetX - 40, this.props.height - 20 - e.nativeEvent.offsetY);
        }
    }

    onMouseDown(e) {
        this.setState({
            diffX: e.nativeEvent.offsetX,
            diffY: e.nativeEvent.offsetY,
            moving: true
        });
    }

    onMouseUp() {
        this.setState({
            moving: false
        });
    }

    onMouseMove(e) {
        if (this.state.moving) {
            this.moveLeft(e.nativeEvent.offsetX - this.state.diffX);
            this.moveDown(this.state.diffY - e.nativeEvent.offsetY);
            this.setState({
                diffX: e.nativeEvent.offsetX,
                diffY: e.nativeEvent.offsetY,
            });
        }
    }

    render() {
        return (
            <div>
                <div id="zoomControls">
                    <a className="buttonZoom" onClick={ () => this.moveLeft(10) }>&larr;</a>
                    <a className="buttonZoom" onClick={ () => this.moveLeft(-10) }>&rarr;</a>
                    <a className="buttonZoom" onClick={ () => this.moveDown(-10) }>&uarr;</a>
                    <a className="buttonZoom" onClick={ () => this.moveDown(10) }>&darr;</a>
                    <a className="buttonZoom" onClick={ () => this.zoomIn(0, 0) }>zoom in</a>
                    <a className="buttonZoom" onClick={ () => this.zoomOut(0, 0) }>zoom out</a>
                    <span>{this.state.multiplier}</span>
                </div>
                <svg width={this.props.width} height={this.props.height}
                     className={this.state.moving ? 'moving' : ''}
                     onWheel={(e) => this.wheelZoom(e)}
                     onMouseMove={(e) => this.onMouseMove(e)}
                     onMouseDown={(e) => this.onMouseDown(e)}
                     onMouseLeave={this.onMouseUp}
                     onMouseUp={this.onMouseUp}
                     >
                    <Axis
                        x={40}
                        y={this.props.height - 20}
                        margin={this.state.left}
                        multiplier={this.state.multiplier}
                        length={this.props.width - 60}
                        horizontal={true}
                    />
                    <Axis
                        x={40}
                        y={this.props.height - 20}
                        margin={this.state.bottom}
                        multiplier={this.state.multiplier}
                        length={this.props.height - 40}
                        width={this.props.width - 20}
                        horizontal={false}
                    />
                    <clipPath id="graphClipPath">
                        <rect x={40} y={20} width={this.props.width - 40} height={this.props.height - 40}/>
                    </clipPath>
                    <g style={{clipPath: 'url(#graphClipPath)'}} >
                        <GraphBody
                            x={-this.state.left + 40}
                            y={this.props.height - 20}
                            bot={this.state.bottom}
                            data={this.props.data}
                            multiplier={this.state.multiplier}
                        />
                    </g>
                </svg>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/graph-components/graph.js